import { useQuery } from '@tanstack/react-query'
import { addDays, format } from 'date-fns'
import { ReservationsService, type Reservation } from '@/services/reservations'

const UPCOMING_LIMIT = 10
// El filtre `estat` del backend és d'igualtat exacta: una llista amb comes
// ('CONFIRMED,CHECKED_IN') no coincidia mai i el widget sortia sempre buit.
// Per això fem una crida per estat i les ajuntem aquí.
const UPCOMING_STATUSES = ['CONFIRMED', 'CHECKED_IN'] as const

export async function fetchUpcomingReservations(today: Date = new Date()): Promise<Reservation[]> {
    const params = {
        data_inici: format(today, 'yyyy-MM-dd'),
        data_fi: format(addDays(today, 7), 'yyyy-MM-dd'),
        per_page: UPCOMING_LIMIT,
        sort_by: 'data_entrada',
        sort_order: 'asc',
    }

    const responses = await Promise.all(
        UPCOMING_STATUSES.map((estat) => ReservationsService.getAll({ ...params, estat })),
    )

    const byId = new Map<string, Reservation>()
    for (const response of responses) {
        for (const reservation of response.data || []) {
            byId.set(reservation.id, reservation)
        }
    }

    return [...byId.values()]
        .sort((a, b) => a.data_entrada.localeCompare(b.data_entrada))
        .slice(0, UPCOMING_LIMIT)
}

export function useUpcomingReservations() {
    return useQuery({
        queryKey: ['upcoming-reservations'],
        queryFn: () => fetchUpcomingReservations(),
        staleTime: 1000 * 60 * 5, // 5 minutes
    })
}
